import { httpsCallable } from "firebase/functions";
import { functions } from "../firebase";
import { callAdminFunction } from "./documentUploadAdminService";

// India data lives in its own database; the dashboard reaches it only through
// these callables (admin check happens on the server).

const withReadableErrors = async (request) => {
  try {
    return await request();
  } catch (error) {
    // A bare "internal" means the function could not be reached at all.
    if (error?.code === "functions/internal" && error?.message === "internal") {
      throw new Error("India admin service is not reachable. Please try again later.");
    }
    throw error;
  }
};

const call = (name, payload = {}) =>
  withReadableErrors(async () => {
    const result = await httpsCallable(functions, name)(payload);
    return result.data || {};
  });

/**
 * @param {"pending"|"approved"|"rejected"|"all"} status
 */
export const listIndiaProviders = (status = "pending") =>
  call("adminListIndiaProviders", { status });

export const getIndiaProvider = (providerId) =>
  call("adminGetIndiaProvider", { providerId });

/**
 * Decrypts one KYC value. The server logs every reveal with the reason.
 *
 * @param {string} providerId
 * @param {"aadhaar"|"pan"|"bankAccountNumber"} field
 * @param {string} reason
 */
export const revealIndiaKyc = (providerId, field, reason) =>
  call("adminRevealIndiaKyc", { providerId, field, reason });

export const approveIndiaProvider = (providerId) =>
  call("adminSetIndiaProviderApproval", { providerId, decision: "approved" });

/**
 * Same payload as the Australian rejectProviderApplication.
 *
 * @param {string} providerId
 * @param {{reasons: string[], reuploadItems: string[], missingDetails: string[]}} rejection
 */
export const rejectIndiaProvider = (providerId, { reasons, reuploadItems, missingDetails }) =>
  call("adminSetIndiaProviderApproval", {
    providerId,
    decision: "rejected",
    reasons,
    reuploadItems,
    missingDetails,
  });

export const getIndiaProviderDocuments = (providerId) =>
  withReadableErrors(() =>
    callAdminFunction("getProviderDocumentsForReviewIn", { providerId, limit: 100 }),
  );

export const reviewIndiaProviderDocument = (payload) =>
  withReadableErrors(() => callAdminFunction("reviewProviderDocumentIn", payload));
